/**
 * Client schedule (client view) – get schedule for current user.
 */
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'clientSchedules';

export async function getByClient(clientId) {
  const q = query(
    collection(db, COLLECTION),
    where('clientId', '==', clientId),
    limit(1)
  );
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export const clientScheduleRepo = { getByClient };
